import { HTMLAttributes, useEffect, useState } from 'react';

import { decode } from 'js-base64';
import Cookies from 'js-cookie';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { baseUrl, dApi } from '@plugins/axios/api';

import { useRecoil } from '@hooks/useRecoil';

export interface AuthGuardProps extends HTMLAttributes<HTMLDivElement> {}

const privatePath = ['partner', 'funeral'];

export const AuthGuard = ({ ...props }: AuthGuardProps) => {
  const { useRecoilState, useAtom } = useRecoil();
  const [isToken, setIsToken] = useState(true);
  const [isTokenChecking, setIsTokenChecking] = useState(false);
  const [profile, setProfile] = useRecoilState(
    useAtom<{ uid: number; role: 'partner' | 'funeral'; name: string } | null>(
      'USER_PROFILE',
    ),
  );

  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (profile === null) {
      const refreshToken = Cookies.get('REPLHADA_ADMIN_REFRESH_TOKEN');

      if (refreshToken) {
        setIsToken(true);
        const { uid, role, name } = JSON.parse(
          decode(refreshToken.split('.')[1]),
        );
        setProfile({
          uid: Number(uid),
          role,
          name,
        });
        if (!isTokenChecking) {
          setIsTokenChecking(true);
          setTimeout(
            () =>
              dApi
                .post(
                  `${baseUrl}/auth/refresh`,
                  {},
                  {
                    headers: { authorization: 'Bearer ' + refreshToken },
                  },
                )
                .then(({ data }) => {
                  Cookies.set(
                    'REPLHADA_ADMIN_ACCESS_TOKEN',
                    data['accessToken'],
                  );
                  const { uid, role, name } = JSON.parse(
                    decode(refreshToken.split('.')[1]),
                  );
                  setProfile({
                    uid: Number(uid),
                    role,
                    name,
                  });
                })
                .catch(() => {
                  Cookies.remove('REPLHADA_ADMIN_ACCESS_TOKEN');
                  Cookies.remove('REPLHADA_ADMIN_REFRESH_TOKEN');
                  setProfile(null);
                  setIsToken(false);
                }),
            1200,
          );
        }
      } else {
        Cookies.remove('REPLHADA_ADMIN_ACCESS_TOKEN');
        Cookies.remove('REPLHADA_ADMIN_REFRESH_TOKEN');
        setProfile(null);
        setIsToken(false);
      }
    }
  }, [profile, setProfile, isTokenChecking]);

  useEffect(() => {
    if (
      profile !== null &&
      (pathname.includes(privatePath[0]) || pathname.includes(privatePath[1]))
    ) {
      if (
        profile.role === privatePath[0] &&
        pathname.includes(privatePath[1])
      ) {
        console.log('navigate 처리됨, partner 권한 밖');
        navigate('/permisson-denied');
      }

      if (
        profile.role === privatePath[1] &&
        pathname.includes(privatePath[0])
      ) {
        console.log('navigate 처리됨, 장례식장 권한 밖');
        navigate('/permisson-denied');
      }
    }
  }, [profile, pathname, navigate]);

  // if (profile === null)
  //   return (
  //     <div className='container flex h-full w-full justify-center' {...props}>
  //       <div className='relative mt-[calc(50vh-160px)] flex h-[240px] min-w-[380px] flex-col items-center justify-center rounded-md bg-[#116e334f]'>
  //         <span className='loading' />
  //         <h3 className='pl-1 pt-2 font-semibold text-[#116e33]'>
  //           Loading ...
  //         </h3>
  //       </div>
  //     </div>
  //   );

  // blank string 시 로그인 페이지로 이동
  return isToken ? <Outlet /> : <Navigate to='/login' />;
};
